import store from 'config/store'
import { path } from 'ramda'

export const getSession = () => {
  if (!store || !store.getState){
    return {}
  }

  const {session = {} } : {session:any} = store.getState()

  return session
}

export const getVisitorTimezone = (state) => {
  return path(['session', 'context', 'timezone'], state)
}
